module.exports = __webpack_public_path__ + "img/more_bg.85bd96c9.jpg";